<template>
	<article>
		<div class="cover">
			<i :class="`${objeto.tipoIcone} icon`"></i>
			<div class="descricao">{{objeto.tipoNome.toUpperCase()}}</div>
		</div>

		<div class="infos">
			<div class="controls">
					<button type="button" class="btn small" @click="$router.push( '/objeto/' + objeto.id )"><i class="fas fa-eye"></i></button>
					<button type="button" class="btn small" @click="Cadastro(objeto.id)"><span class="material-icons">playlist_add</span></button>
					<div class="more" v-if= "objeto.autores">
						<div class="credits">
							<p>
								<strong>Autor: </strong> {{ objeto.autores.replace(/\|\~\|/g, ', ') }}
							</p>
						</div>
					</div>
				</div>
			<div class="title-description">
				<h2>
					<router-link :to="{ name: 'objeto', params: { id: objeto.id } }">{{ objeto.titulo }}</router-link>
				</h2>

				<div class="description">
					{{ `${objeto.descricao.length > 50 ? objeto.descricao.substr(1, 150) + '...' : objeto.descricao }` }}
				</div>
			</div>
		</div>
		<div class="details">
			<div class="row">
				<div class="curadoria">Curadoria: {{ objeto.curadoriaNome }}</div>
				<div class="subCuradoria">Sub-Curadoria: {{ objeto.subCuradoriaNome}} </div>
				<div class="Eixo">Eixo: {{objeto.eixoNome}}</div>
				<div class="disRecorrentes" v-if="objeto.disciplinasNomes">Disciplinas recorrentes: {{ objeto.disciplinasNomes }} </div>
				<div class="curRecorrentes" v-if="objeto.cursosNomes">Cursos recorrentes: {{ objeto.cursosNomes }}</div>
				<div class="tagsGerais" v-if="objeto.tagsNomes">Tags gerais: {{objeto.tagsNomes}} </div>
			</div>
		</div>
		<SalvarNaColecao @boxCreate="createCollection" :boxCadastro="boxCadastro" :objetoId="objetoId" v-if="boxCadastro"/>
	</article>

</template>

<script>
import SalvarNaColecao from './../../objeto/SalvarNaColecao'
export default {
	name: 'BoxObjetos',
	components: { SalvarNaColecao },
	props: {
		objeto: {
			type: Object,
			required: true
		}
	},
	methods: {
		Cadastro (id) {
			this.objetoId = id
			this.boxCadastro = !this.boxCadastro
		},
		createCollection (boxCreate) {
			this.boxCadastro = boxCreate
		}
	},
	data () {
		return {
			boxCadastro: false,
			objetoId: null
		}
	}
}
</script>

<style lang="scss" scoped>
article {
	display: grid;
	grid-template-columns: 250px 2fr;
	grid-gap: 0 30px;
	border-bottom: 2px solid #59708F;
	padding-bottom: 10px;

	&:not(:last-of-type) {
		margin-bottom: 50px;
	}
	.details {
		grid-column-start: 1;
		grid-column-end: 3;
		margin-top: 20px;
		.row {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 8px;
			div {
				min-width: 102px;
				min-height: 32px;
				background: #1B2E46 0% 0% no-repeat padding-box;
				border: 1px dashed #FFFFFF;
				border-radius: 5px;
				opacity: 1;
				display: flex;
				margin-right: 9px;
				padding-left: 5px;
				margin-bottom: 9px;
				padding-right: 5px;
				align-items: center;
			}
		}
	}

	// .cover {
	// 	img {
	// 		width: 100%;
	// 		height: 100%;
	// 		border-radius: 5px;
	// 	}
	// }
	.cover {
		background-color: #223244;
		height: 144px;
		align-items: center;
		justify-content: center;
		display: flex;
		background-image: url('../../../../assets/images/bg1_colecao_lista.png');
		background-repeat: no-repeat;
		color: #FFF;
		width: 240px;
		flex-direction: column;
		.icon {
			font-size: 45px;
		}
		.descricao {
			font: Condensed Bold 22px/26px Roboto;
			padding-left: 15px;
			padding-right: 15px;
			text-align: center;
		}
	}

	.infos {
		.title-description {
			h2 {
				font-size: 1.5em;
				font-weight: 700;
				color: #FFFFFF;
				text-transform: uppercase;
				margin-top: 5px;
				margin-bottom: 5px;

				a {
					text-decoration: none;
					color: inherit;
				}
			}

			.tipo {
				margin: -8px 10px 10px 0;
				font-weight: bold;
				color: #8B94A7;
				font-size: 14px;

				display: inline-block;
				padding: 3px 5px;
				background-color: #FFF3;
			}

			.description {
				margin-bottom: 14px;
				letter-spacing: 0px;
				opacity: 1;
				font: Condensed 14px/20px Roboto;
				color: #F8F9FB;
			}
		}

		.controls {
				display: flex;
				padding: 0;

				.btn {
					background: $second-color;
					border: none;
					color: #fff;
					text-decoration: none;
					display: flex;
					justify-content: center;
					align-items: center;
					min-width: 40px;
					min-height: 40px;
					font-size: 1em;
					padding: 2px 10px;
					border-radius: 5px;
					font-weight: 700;
					a {
						width: 30px;
						height: 40px;
					}
				}

				button {
					margin-right: 10px;
					cursor: pointer;
				}
				.more {
					// display: grid;
					// grid-template-columns: auto 190px;
					// grid-gap: 0 40px;
					// align-items: center;
					display: flex;
					justify-content: flex-end;
					width: 100%;

					.credits {
						display: flex;
						color: #8B94a7;

						p {
							&:not(:last-of-type) {
								margin-right: 20px;
							}

							&:first-of-type {
								display: flex;
								align-items: center;

								i {
									font-size: 1.3em;
									margin-right: 6px;
								}
							}

							strong {
								font-weight: 700;
								margin-right: 2px;
							}
						}
					}
				}
			}
	}
}
</style>
